"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7258],{

/***/ 91449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ controlPanel; }
/* harmony export */ });
function controlPanel(status) {
  // const list_panel = Array.from(
  //   document.getElementsByClassName("popup-content-panel")
  // );
  // list_panel.forEach((item, index) => {
  //   item.style.display = status || "none";
  // });
  document.documentElement.removeAttribute("style"); //   document.documentElement.style.overflow = "auto";
}

/***/ }),

/***/ 87258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ molecules_PackageModal; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/action-function/controlPanel.js
var controlPanel = __webpack_require__(91449);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./common/fetch/getGAUserID.js
var getGAUserID = __webpack_require__(12453);
// EXTERNAL MODULE: ./common/fetch/post.js
var post = __webpack_require__(92559);
// EXTERNAL MODULE: ./common/trigger.js
var trigger = __webpack_require__(62951);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/bi/BiLoaderAlt.js
var BiLoaderAlt = __webpack_require__(7778);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaTimes.js
var FaTimes = __webpack_require__(11856);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/fa/FaCaretRight.js

function FaCaretRight(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 192 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiChevronDown.js
var FiChevronDown = __webpack_require__(49604);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/PackageModal/step1.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var Step1 = function Step1() {
  var _useContext = (0,react.useContext)(contexts/* ModalPackageForm */.Dn),
      register = _useContext.register,
      isSubmitting = _useContext.isSubmitting,
      errors = _useContext.errors,
      step = _useContext.step,
      setStep = _useContext.setStep,
      getValues = _useContext.getValues,
      suffix_data = _useContext.suffix_data,
      isReserved = _useContext.isReserved,
      selected = _useContext.selected,
      setSelected = _useContext.setSelected;

  var _useState = (0,react.useState)(),
      companyNameError = _useState[0],
      setCompanyNameError = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "m-auto  flex  max-w-xs ".concat(isReserved ? "flex-col-reverse" : "flex-col"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register("company_name", {
        required: {
          value: true,
          message: "This field is required"
        }
      })), {}, {
        disabled: isSubmitting,
        className: " mt-6  w-full rounded-full border-0 px-4  py-2  text-bbc-gray focus:outline-0 focus:ring-0",
        required: true,
        type: "text",
        placeholder: "Your proposed company name"
      })), companyNameError && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "block  pt-2 pl-2 text-left text-sm text-red-500",
        children: "This field is required"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox */.Ri, {
        value: selected,
        onChange: function onChange(value) {
          setSelected(value);
        },
        children: function children(_ref) {
          var open = _ref.open;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative mt-6 text-left ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Listbox.Button */.Ri.Button, {
              className: "relative w-full cursor-pointer rounded-full bg-white py-2 px-6 pr-10 text-left text-bbc-gray focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "block truncate  text-base",
                children: selected.name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "pointer-events-none absolute inset-y-0 right-1 flex items-center pr-2",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
                  size: 20,
                  className: "absolute right-3  float-right transform align-middle text-bbc-brand-500  ".concat(open ? "rotate-180" : "rotate-0", " transition-all duration-200"),
                  "aria-hidden": "true"
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Options */.Ri.Options, {
              className: "absolute mt-1 max-h-60 w-full overflow-auto rounded-xl bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
              children: suffix_data.CompanySuffixes.map(function (suffix) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
                  className: function className(_ref2) {
                    var active = _ref2.active;
                    return "relative cursor-default select-none py-2 pl-10 pr-4 ".concat(active ? "bg-bbc-brand-100 text-bbc-brand-800" : "text-gray-900");
                  },
                  value: suffix,
                  children: function children(_ref3) {
                    var selected = _ref3.selected;
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "block truncate ".concat(selected ? "font-medium" : "font-normal"),
                        children: suffix.name
                      }), selected ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "absolute inset-y-0 left-0 flex items-center pl-3 text-bbc-brand-400",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaCaretRight, {
                          className: "h-5 w-5",
                          "aria-hidden": "true"
                        })
                      }) : null]
                    });
                  }
                }, suffix.id);
              })
            })]
          });
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
      type: "button",
      othersClass: "mt-6",
      onClick: function onClick() {
        if (getValues("company_name") === "") {
          setCompanyNameError(true);
        } else {
          setStep(step + 1);
        }
      },
      children: "Next"
    })]
  });
};

/* harmony default export */ var step1 = (Step1);
;// CONCATENATED MODULE: ./components/molecules/PackageModal/step2.js


function step2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function step2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { step2_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { step2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var Step2 = function Step2() {
  var _errors$first_name, _errors$email;

  var _useContext = (0,react.useContext)(contexts/* ModalPackageForm */.Dn),
      register = _useContext.register,
      isSubmitting = _useContext.isSubmitting,
      errors = _useContext.errors;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "m-auto max-w-xs text-left",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", step2_objectSpread(step2_objectSpread({}, register("first_name", {
      required: {
        value: true,
        message: "This field is required"
      }
    })), {}, {
      className: " mt-6  w-full rounded-full border-0 px-4  py-2  text-bbc-gray focus:outline-none",
      required: true,
      disabled: isSubmitting,
      type: "text",
      placeholder: "Your Full Name"
    })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "block pt-2 pl-2 text-sm text-red-500",
      children: (_errors$first_name = errors.first_name) === null || _errors$first_name === void 0 ? void 0 : _errors$first_name.message
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", step2_objectSpread(step2_objectSpread({
      type: "email"
    }, register("email", {
      required: {
        value: true,
        message: "Email is required"
      },
      pattern: {
        value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
        message: "Invalid e-mail"
      }
    })), {}, {
      placeholder: "Your Email:",
      pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      className: " mt-6  w-full rounded-full border-0 px-4  py-2  text-bbc-gray transition-colors duration-200 invalid:border-pink-500 invalid:text-pink-600 focus:bg-white focus:outline-none focus:outline-hidden focus:ring-0 focus:invalid:border-pink-500 focus:invalid:ring-pink-500"
    })), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "block pt-2 pl-2 text-sm text-red-500",
      children: (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
    })]
  });
};

/* harmony default export */ var step2 = (Step2);
;// CONCATENATED MODULE: ./components/molecules/PackageModal/index.js

















/** ========== */




var PackageModal = function PackageModal(props) {
  /* Variables Define */
  var country_name = props.country_name,
      country_id = props.country_id,
      show = props.show,
      suffix_data = props.suffix_data,
      isReserved = props.isReserved,
      onHide = props.onHide;

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      getValues = _useForm.getValues,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  var _useContext = (0,react.useContext)(contexts/* ToastContext */.uL),
      openAlert = _useContext.openAlert;

  var _useState = (0,react.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var recaptchaRef = (0,react.useRef)();

  var _useState2 = (0,react.useState)(suffix_data === null || suffix_data === void 0 ? void 0 : suffix_data.CompanySuffixes[0]),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      step = _useState3[0],
      setStep = _useState3[1];

  var companyName = getValues("company_name");
  /* Handle Event */

  var closeModal = function closeModal() {
    reset();
    clearErrors();
    setStep(0);
    setSelected(suffix_data.CompanySuffixes[0]);
    setLoading(false);
    onHide();
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
      var token, GAUserID;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context2.sent;

              if (token) {
                GAUserID = (0,getGAUserID/* default */.Z)();
                data.client_id = GAUserID ? GAUserID : "";
                data.company_suffix_id = parseInt(selected.id, 10);
                data.website_id = "1";
                data.company_country_id = country_id;

                try {
                  (0,post/* default */.Z)({
                    api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/check_name"),
                    data: data,
                    token: token
                  }).then( /*#__PURE__*/function () {
                    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(res) {
                      return regenerator_default().wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!res.state) {
                                _context.next = 6;
                                break;
                              }

                              (0,trigger/* default */.Z)("contact_form", data, "Check name - ".concat(country_name));
                              _context.next = 4;
                              return openAlert(3000, "success", "", closeModal());

                            case 4:
                              _context.next = 10;
                              break;

                            case 6:
                              _context.next = 8;
                              return openAlert(3000, "error");

                            case 8:
                              (0,controlPanel/* default */.Z)("inline-flex");
                              console.log("error");

                            case 10:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }())["catch"](function (e) {
                    openAlert(3000, "error");
                    (0,controlPanel/* default */.Z)("inline-flex");
                    console.log("error", e);
                  });
                } catch (e) {
                  clearErrors();
                  openAlert(3000, "error");
                  console.log("error", e);
                  (0,controlPanel/* default */.Z)("none");
                }
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(contexts/* ModalPackageForm.Provider */.Dn.Provider, {
    value: {
      register: register,
      isSubmitting: isSubmitting,
      errors: errors,
      step: step,
      setStep: setStep,
      getValues: getValues,
      country_id: country_id,
      suffix_data: suffix_data,
      isReserved: isReserved,
      selected: selected,
      setSelected: setSelected
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
      appear: true,
      show: show,
      as: "div",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Dialog */.Vq, {
        as: "div",
        unmount: true,
        className: "fixed inset-0 overflow-y-auto",
        style: {
          zIndex: 99
        },
        onClose: function onClose() {},
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          "aria-hidden": "true",
          className: "min-h-screen px-4 text-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
            as: react.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Dialog.Overlay */.Vq.Overlay, {
              className: "fixed inset-0 bg-slate-900 bg-opacity-70"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "inline-block h-screen align-middle",
            "aria-hidden": "true",
            children: "\u200B"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
            as: react.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "popup-content-panel relative inline-flex  w-full  transform  flex-col justify-center rounded-2xl border-2 bg-gradient-to-br from-[#81F5FF] to-[#FFD5E5] px-4 py-10 text-center align-middle shadow-xl transition-all",
              style: {
                minHeight: "600px",
                maxWidth: "400px"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "absolute top-6 right-4 z-10",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  type: "button",
                  className: "inline-flex justify-center rounded-full border-2 border-white p-1 text-xs  font-medium text-white transition-all  hover:border-bbc-red-300 hover:text-bbc-red-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                  onClick: closeModal,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaTimes/* FaTimes */.a, {
                    size: 12
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: " relative z-10 ",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
                  onSubmit: handleSubmit(onSubmit),
                  children: [step === 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                      className: "text-center text-3xl font-semibold leading-[44px] text-bbc-brand-700",
                      children: ["Check your company name availability in ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", country_name]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(step1, {})]
                  }), step === 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                      className: "text-center text-3xl font-semibold leading-[44px] text-bbc-brand-700",
                      children: ["How we can reach you out about result of ", companyName, " ", selected.name]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(step2, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
                      ref: recaptchaRef,
                      sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
                      badge: "inline",
                      size: "invisible",
                      className: "my-6 flex justify-center "
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonNew/* default */.Z, {
                      type: "submit",
                      othersClass: "min-w-[170px] relative",
                      disabled: loading,
                      onClick: function onClick() {
                        if (isSubmitting) setLoading(true);
                      },
                      children: [isSubmitting && /*#__PURE__*/(0,jsx_runtime.jsx)(BiLoaderAlt/* BiLoaderAlt */.s, {
                        className: "absolute left-4 top-2.5 animate-spin",
                        size: 20
                      }), "Check Now"]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                      className: "mt-3 block cursor-pointer text-base text-white",
                      onClick: function onClick() {
                        setStep(step - 1);
                      },
                      children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)("u", {
                        children: "Go back"
                      })]
                    })]
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "absolute bottom-0 left-0 h-full w-full overflow-hidden rounded-2xl",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/common/package_popup_bg.png",
                  width: 400,
                  height: 427,
                  alt: "Background popup",
                  wrapper: {
                    className: "absolute w-full h-auto left-0 z-0 ",
                    style: {
                      bottom: "-80px"
                    }
                  }
                })
              })]
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ var molecules_PackageModal = (PackageModal);
PackageModal.defaultProps = {};
/** ========== */

/***/ })

}]);